var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"title":" Cursos","link":""}}),_c('ProductSlider',{staticClass:"m-5",attrs:{"products":_vm.all_products,"id":"graduates"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }